package org.zq.astrock_ai.storage

import kotlinx.browser.localStorage

actual object ResearchKvStorage {
    actual fun get(key: String): String? =
        runCatching { localStorage.getItem(PREFIX + key) }.getOrNull()

    actual fun put(key: String, value: String) {
        runCatching { localStorage.setItem(PREFIX + key, value) }
    }

    private const val PREFIX = "astockai.research.kv."
}
